/**
 * Display helpers for compact admin task ticket rows.
 */

function engineerLabel(engineer) {
  if (!engineer) return null;
  const given = engineer.given_name?.trim() || '';
  const family = engineer.family_name?.trim() || '';
  const name = [given, family].filter(Boolean).join(' ').trim();
  if (name) return name;
  if (engineer.email?.trim()) return engineer.email.trim();
  if (engineer.company_name?.trim()) return engineer.company_name.trim();
  return null;
}

function assigneeLabel(task) {
  const started = engineerLabel(task.started_by_field_engineer);
  if (started) return started;
  if (task.assigned_to_email?.trim()) return task.assigned_to_email.trim();
  return null;
}

function completedByLabel(task) {
  return engineerLabel(task.completed_by_field_engineer);
}

/** Second row: assignee, or assignee > completed by when both differ. */
export function formatTaskPeopleLine(task) {
  const assignee = assigneeLabel(task);
  const completedBy = completedByLabel(task);

  if (assignee && completedBy && assignee !== completedBy) {
    return `${assignee} > ${completedBy}`;
  }
  if (assignee) return assignee;
  if (completedBy) return completedBy;
  return null;
}

/** First row: asset name : workflow name */
export function formatTaskTitleLine(task, { hideAssetName = false } = {}) {
  const assetName = task.asset?.name || '—';
  const workflowName = task.workflow?.name || 'Workflow';
  if (hideAssetName) return workflowName;
  return `${assetName}: ${workflowName}`;
}

/** Client-side search text for task ticket lists. */
export function taskTicketFilterValue(task) {
  return [
    task.asset?.name,
    task.workflow?.name,
    formatTaskTitleLine(task),
    formatTaskPeopleLine(task),
    task.assigned_to_email,
    task.ticket_reference,
    task.completed_at ? 'closed' : 'open',
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
}
